import type {
  DocumentOcrApiResponse,
  PersistedUploadedDocument,
  StructuredDocumentData,
} from "@/shared/types/documentuploadtype";

export function extractStructuredOcrData(response: unknown): StructuredDocumentData | undefined {
  const result = response as DocumentOcrApiResponse | undefined;

  return result?.results?.[0]?.structured_data || result?.structured_data;
}

export function mergeStructuredOcrDocuments<TFieldKey extends string>(
  documents?: Partial<Record<TFieldKey, PersistedUploadedDocument<TFieldKey>>>
): StructuredDocumentData {
  return (
    Object.values(documents || {}) as Array<PersistedUploadedDocument<TFieldKey> | undefined>
  ).reduce<StructuredDocumentData>(
    (accumulator, document) => ({
      ...accumulator,
      ...(document?.structuredData || {}),
    }),
    {}
  );
}
